import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import './Frame.css'
import template from './Frame.jinja'

var Frame = Backbone.View.extend({
    template: template,

    render (){
        let $html = $(this.template.render())
        this.setElement($html)

        return this
    }
})

export default Frame


// WEBPACK FOOTER //
// ./assets/app/front/components/Frame/Frame.js